import { JetView } from "webix-jet";

export default class BaseGrid extends JetView {
	config() {
		let table = {
			view: "datatable",
			localId: "table",
			rowHeight: webix.skin.$active.rowHeight,
			headerRowHeight:
				webix.skin.$active.barHeight - webix.skin.$active.borderWidth * 2,
			select: true,
			on: {
				onAfterSelect: id => this.ShowDetails(id),
			},
			columns: [],
		};

		return table;
	}

	/*shows details view*/
	ShowDetails() {}

	/* initializes search properties and attaches event listening for search input*/
	InitSelf(data, id) {
		/* loads data and selects first entity in the table */
		const table = this.$$("table");
		(data.waitData || table.waitData).then(() => {
			if (id) this.$$("table").select(id);
			this.on(this.getParam("state", true).$changes, "search", v =>
				this.Find(v)
			);
			this.Table = table;
		});

		table.parse(data);
	}

	// select a new item
	urlChange() {
		const t = this.Table;
		let id = this.getParam("id", true);
		if (t && id && t.select && t.getSelectedId() != id) {
			t.select(id);
			t.showItem(id);
		}
	}

	EscapeRegExp(text) {
		return text.replace(/[[\]{}()*+?.\\^$|]/g, "\\$&");
	}

	/* filters table by input text and highlights occurrences*/
	Find(text) {
		let table = this.$$("table");
		this.EscapedSearchText = this.EscapeRegExp(text || "");

		if (text) {
			text = text.toLowerCase();
			table.filter(data => this.SearchCompare(text, data));
		} else table.filter();
	}
}
